export enum RecommendedAdjustmentsKeys {
  Locations = 'locations',
  LevelsOfExperience = 'levelsOfExperience',
  CompanySizes = 'companySizes',
  MustHaves = 'mustHaves',
  JobTitle = 'jobTitle',
}
